var _defs, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d5c88;}.cls-2{fill:#2bb3ce;}.cls-3{fill:#9a615b;}.cls-4{fill:#1473a8;}.cls-5{fill:#f8c09c;}.cls-6{fill:#7d8f9f;}.cls-7{fill:#ef937d;}.cls-8{fill:#ffd884;}.cls-9{fill:#ea676b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61,38.938H17a21.934,21.934,0,0,0,7,16.086v5.914H56V52.9A21.906,21.906,0,0,0,61,38.938Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45,52.938h0a7,7,0,0,1-7-7v-1h7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31,38.938v6H60.164a21.965,21.965,0,0,0,.839-6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.003,
    y: 38.938,
    width: 4,
    height: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 44.003,
    y: 44.938,
    width: 2,
    height: 16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61,2.938H26a23,23,0,0,0-23,23v1a20.991,20.991,0,0,0,38.22,12H61Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32,27.938a23.9,23.9,0,0,0,16.9,7L61,34.866V2.938H26a23,23,0,0,0-22.449,18H15.1A23.9,23.9,0,0,1,32,27.938Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M8.5,32.938v-2a1.5,1.5,0,1,0,0-3v-2a3.5,3.5,0,0,1,0,7Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 3.003,
    y: 13.938,
    width: 58,
    height: 7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 12.003,
    y: 17.938,
    width: 2,
    height: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 16.003,
    y: 17.938,
    width: 2,
    height: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 20.003,
    y: 17.938,
    width: 2,
    height: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 24.003,
    y: 16.938,
    width: 2,
    height: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 8.003,
    y: 16.938,
    width: 2,
    height: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 28.003,
    y: 17.938,
    width: 2,
    height: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 32.003,
    y: 17.938,
    width: 2,
    height: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.003,
    y: 17.938,
    width: 2,
    height: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 40.003,
    y: 16.938,
    width: 2,
    height: 4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 44.003,
    y: 17.938,
    width: 2,
    height: 3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 48.003,
    y: 17.938,
    width: 2,
    height: 3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 52.003,
    y: 17.938,
    width: 2,
    height: 3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 56.003,
    y: 16.938,
    width: 2,
    height: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyFat);
export default __webpack_public_path__ + "static/media/body-fat.52dbab782ae65b78c8f7ee9b888b705f.svg";
export { ForwardRef as ReactComponent };